import { Button, Collapse, Grid } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import React, { Fragment } from "react";
import { useState } from "react";
import {
  StyledDataText,
  StyledDataTitle,
  StyledGrid,
  StyledStack,
  StyledTitle,
} from "./SingleMessages.style";
import { theme } from "styles/mui-config";
import BackButton from "components/shared/BackButton";
import { useEffect } from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import {
  getStudentMessagesByIdRequest,
  getTeacherMessageByIdRequest,
} from "api/requests";
import { useParams } from "react-router-dom";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";

export default function SingleMessage() {
  const { message_id } = useParams();
  const [messageData, setMessageData] = useState("");

  const { loading, request } = useHttp(false);

  const [open, setOpen] = useState();

  const getMessageById = async () => {
    const [res] = await request({
      url: () => getTeacherMessageByIdRequest(message_id),
    });
    if (res) {
      setMessageData({
        title: res?.title,
        added_by_type: res.added_by_type ? "admin" : "ثبت نشده",
        sender: res?.sender
          ? `${res.sender.first_name} ${res.sender.last_name}`
          : "ثبت نشده",
        date: res?.created_at?.string ?? "ثبت نشده",
        text: res?.text_message,
      });
    }
  };

  useEffect(() => {
    getMessageById();
  }, []);

  return (
    <DrawerCM title="پیام دریافت شده" $styledHeader>
      <Grid item xs={12} my={3}>
        <BackButton />
      </Grid>
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container>
          {messageData ? (
            <StyledStack>
              <StyledTitle>پیام</StyledTitle>
              <Grid container>
                <StyledGrid item md={3} sm={6} xs={12}>
                  <StyledDataTitle>عنوان پیام</StyledDataTitle>
                  <StyledDataText>{messageData?.title}</StyledDataText>
                </StyledGrid>
                <StyledGrid item md={3} sm={6} xs={12}>
                  <StyledDataTitle>توسط</StyledDataTitle>
                  <StyledDataText>
                    {messageData?.added_by_type === "admin" ? "مدیر" : "مدرس"}
                  </StyledDataText>
                </StyledGrid>
                <StyledGrid item md={3} sm={6} xs={12}>
                  <StyledDataTitle>فرستنده</StyledDataTitle>
                  <StyledDataText>{messageData?.sender}</StyledDataText>
                </StyledGrid>
                <StyledGrid item md={3} sm={6} xs={12}>
                  <StyledDataTitle>تاریخ</StyledDataTitle>
                  <StyledDataText>{messageData?.date}</StyledDataText>
                </StyledGrid>
                <StyledGrid item xs={12}>
                  <StyledDataTitle> متن پیام</StyledDataTitle>
                  <StyledDataText
                    sx={{
                      marginBottom: 2,
                      textAlign: "justify",
                      display: { md: "block", xs: "none" },
                    }}
                  >
                    {messageData.text}
                  </StyledDataText>
                  <StyledDataText
                    sx={{
                      marginBottom: 2,
                      display: { xs: "block", md: "none" },
                      textAlign: "justify",
                    }}
                  >
                    {messageData?.text.length < 500 ? (
                      messageData?.text
                    ) : (
                      <Fragment>
                        <Collapse in={open} collapsedSize={95}>
                          {messageData.text}
                        </Collapse>
                        <Button
                          color="primary"
                          onClick={() => setOpen((prev) => !prev)}
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "right",
                            marginY: 2,
                          }}
                          endIcon={open ? <RemoveIcon /> : <AddIcon />}
                        >
                          {open ? "بستن" : "ادامه"}
                        </Button>
                      </Fragment>
                    )}
                  </StyledDataText>
                </StyledGrid>
              </Grid>
            </StyledStack>
          ) : (
            <StyledStack>{"پیامی دریاف نشده است"}</StyledStack>
          )}
        </Grid>
      )}
    </DrawerCM>
  );
}
